module.exports = __webpack_public_path__ + "img/error.92e977b7.svg";